export default "__VITE_ASSET__aZVnUks2__"